// Options whose value always sinks to the bottom of a sorted list, regardless
// of locale. The "—" not-set sentinel (TableCell filters / optional selects)
// must stay last so the "clear / is empty" pick never lands mid-alphabet.
const PIN_LAST = new Set(["—"]);

/**
 * Locale-aware alphabetical sort for SELECT option lists. Sorts on the
 * *displayed* label, not the raw key: pass `labelOf` so translated built-in
 * enums and raw-value fields (language/timeZone, whose value is a code like
 * "en" but whose label is "English") order by what the user actually reads.
 *
 * Returns a new array; never mutates the input. Pinned sentinels ("—") are
 * kept at the end in their original order. `localeCompare` with the active
 * locale is what makes accents / umlauts / non-Latin scripts sort correctly —
 * a plain `.sort()` would fall back to UTF-16 code-unit order.
 */
export function sortOptionsForDisplay(
  options: string[],
  labelOf?: (option: string) => string,
  locale?: string,
): string[] {
  const pinned: string[] = [];
  const rest: string[] = [];
  for (const option of options) {
    (PIN_LAST.has(option) ? pinned : rest).push(option);
  }
  rest.sort((a, b) =>
    (labelOf?.(a) ?? a).localeCompare(labelOf?.(b) ?? b, locale, {
      sensitivity: "base",
    }),
  );
  return [...rest, ...pinned];
}
